var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from 'react'; // tslint:disable-line
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('credit-layout');
import { breakpoints } from '@shapeable/theme';
import { CreditLogo } from './credit-logo';
export var CreditLayoutDefaultProps = {
  inverted: false,
  href: '/',
  target: '_self'
};
// -------- Styles -------->
var LinkStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  "])))
});
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    transition: all 0.15s;\n    height: 36px;\n\n    svg {\n      height: 100%;\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    transition: all 0.15s;\n    height: 36px;\n\n    svg {\n      height: 100%;\n    }\n  "]))),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "]))),
  last: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    @media screen and (min-width: 1235px) {\n      margin-left: 0;\n    }\n  "], ["\n    @media screen and (min-width: 1235px) {\n      margin-left: 0;\n    }\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n  "], ["\n    height: 100%;\n    width: 100%;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: styled.a.attrs(cls.attr('link'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var CreditLayout = function (props) {
  var className = props.className,
    href = props.href,
    target = props.target;
  return React.createElement(My.Link, {
    target: target,
    href: href,
    className: cls.name(className)
  }, React.createElement(My.Container, null, CreditLogo && React.createElement(CreditLogo, null)));
};
CreditLayout.defaultProps = CreditLayoutDefaultProps;
CreditLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;